// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu__VlpdN","Carousel":"Menu_Carousel__+JZz5"};